<template>
    <div class="py-4">
        <div class="flex flex-col w-full shadow-md  bg-white py-6 px-10 font-sans rounded-lg bg-white">
            <template>
                <div @click="showEvent = !showEvent" class="flex justify-between items-center border-b-2 py-4">
                    <div class="w-full text-menuOrder-dark-blue font-bold font-sans text-base">
                        24 - 25 cентября, Назад в 90-е
                    </div>
                    <div class="flex px-4 text-2xl">
                        <font-awesome-icon
                                :icon="['far', 'angle-down']"
                                :class="rotateArrow"
                                fixed-width
                                class="text-grey-darker"
                        ></font-awesome-icon>
                        <font-awesome-icon
                                :icon="['fal', 'ellipsis-v']"
                                class="text-grey-darker"
                                fixed-width
                        ></font-awesome-icon>

                    </div>
                </div>
                <div v-if="showEvent" class="flex w-full flex-wrap  justify-start ">
                    <div class="w-113 mr-10" :key="key" v-for="(el, key) in array">
                        <div class="flex w-full mt-4 ">
                            <div class="bg-brand-darker w-113 rounded-lg flex-col pt-24  shadow-md ">
                                <div class="flex flex-col bg-white w-full mt-8 pb-6 pl-4 pr-4 items-start rounded-b-lg">
                                    <div class="flex w-full mt-4 justify-between border-b-2 pb-2">
                                        <div class="text-2xl font-sans font-extrabold text-brand-light tracking-tight">
                                            Сентября
                                        </div>
                                        <img class="mr-2" src="@/assets/SVG/calendar-transparrent.svg"/>
                                    </div>
                                    <div class="flex flex-col mt-8">
                                        <div class="text-2xl font-sans font-extrabold text-brand-darker-light tracking-tight">
                                            Назад в 90
                                        </div>
                                        <div class="text-mxs font-sans font-medium text-brand-darker-light tracking-tight">24
                                            тематическая игра
                                        </div>
                                    </div>
                                    <div class="flex flex-col text-brand-darker-light mt-6">
                                        <div class="flex ">
                                            <img class="mr-2" src="@/assets/SVG/clock-transparrent.svg"/>
                                            <div class="text-base font-sans font-medium text-brand-light tracking-tight">Начало
                                                в 19:00
                                            </div>
                                        </div>
                                        <div class="flex mt-2">
                                            <img class="mr-3" src="@/assets/SVG/gps-transparrent.svg"/>
                                            <div class="text-base font-sans font-medium text-brand-light tracking-tight">Начало
                                                в 19:00
                                            </div>
                                        </div>
                                        <div class="flex mt-2">
                                            <img class="mr-2" src="@/assets/SVG/price-transparrent.svg"/>
                                            <div class="text-base font-sans font-extrabold text-brand-light tracking-tight">
                                                300
                                            </div>
                                        </div>
                                    </div>

                                    <div class="flex flex-col text-brand-darker-light mt-6">
                                        <div class="text-xl font-sans font-extrabold tracking-tight ">Регистрация</div>
                                        <div class="text-xl font-sans font-extrabold tracking-tight ">откроется</div>
                                        <div class="text-xl font-sans font-medium tracking-tight font-sans">16 сентября / 12:00
                                        </div>
                                    </div>
                                    <button class="mt-4 border-2 bg-brand-light rounded-full w-2/5 pt-2 pb-2 text-white font-sans font-medium tracking-tight">
                                        Регистрация
                                    </button>
                                </div>

                            </div>

                        </div>
                    </div>

                </div>


                <div class="flex flex-row justify-end mr-10 mt-3">
                    <button class="flex flex-row  hover-up font-bold bg-brand-green  text-white text-white rounded-full py-2 px-4 pl-16 pr-16">
                        Опубликовать
                    </button>

                </div>
            </template>
        </div>
    </div>


</template>

<script>
export default {
  name: 'calendar-of-events',
  data() {
    return {
      array: [0, 1, 2, 3, 4, 5, 6, 7, 8],
      showEvent: true,
    };
  },
  computed: {
    rotateArrow() {
      return [this.showEvent ? '' : 'rotate-arrow', 'arrow'];
    },
  },
};
</script>

<style scoped>
    .arrow {
        transition: 0.5s all;
    }
    .rotate-arrow {
        transform: rotate(180deg);
    }

</style>
